let lastTraceId: string | null = null;
let lastSeenAt: number = 0;

export const TraceStore = {
  // Save the ID and the current time
  save: (id: string | null) => {
    if (!id) return;
    lastTraceId = id;
    lastSeenAt = Date.now();
  },

  // Retrieve only if within the 300ms window
  getValidId: () => {
    const now = Date.now();
    if (lastTraceId && now - lastSeenAt <= 300) {
      return lastTraceId;
    }
    return null; // Expired or non-existent
  },
};

export default TraceStore;
